





























































import Vue from 'vue'
import { InputEvent, Notifications, Message } from '@/interfaces'
import IconNotification from '@/components/icons/IconNotification.vue'
import MessageTabs from '@/components/MessageTabs.vue'
import MessagePanel from '@/components/MessagePanel.vue'
import Modal from '@/components/Modal.vue'
import NoContent from '@/components/NoContent.vue'
import Button from '@/components/Button.vue'
import IconFlagBadge from '@/components/icons/IconFlagBadge.vue'
import { MessageHub } from '../event-hub'
import Router from '../router'
import { AppHub } from '@/event-hub'

export default Vue.extend({
  components: {
    IconNotification,
    IconFlagBadge,
    MessageTabs,
    MessagePanel,
    Modal,
    NoContent,
    Button,
  },
  data() {
    return {
      isOpen: false,
      activeClass: '',
      activeTab: 0,
      showDeleteConfirm: false,
      refreshTimer: 0,
    }
  },
  computed: {
    accountId(): string {
      return this.$store.state.accountId
    },
    notifications(): Notifications {
      return this.$store.getters.notifications
    },
    selectedMessage(): Message {
      return (this as any).notifications.messages[this.activeTab]
    },
    checkedMessageIds(): string[] {
      return this.checkedMessages.map(message => message.id)
    },
    checkedMessages(): any[] {
      return this.notifications.messages.filter(message => message.isChecked == true)
    },
    notificationBadgeNumber(): number {
      return this.notifications.alertCount
    },
  },
  methods: {
    fetchData(refresh = false) {
      // We cannot fetch message until the account has been set
      if (!this.accountId) return
      this.$store.dispatch('fetchMessages', refresh).then(response => {
        this.checkQueryForMessageIds()
      })
    },
    open() {
      this.isOpen = true
      this.activeClass = 'active'
      this.setSelectedMessageAsRead()
    },
    close() {
      this.isOpen = false
      this.activeClass = 'inactive'
      this.$router.push({ path: this.$route.path })
    },
    closed() {
      this.activeClass = 'd-none'
    },
    update() {
      this.checkQueryForMessageIds()
    },
    handleTabClick(index: number) {
      this.activeTab = index
      this.setSelectedMessageAsRead()
      this.$router.push({ path: this.$route.path, query: { message: this.selectedMessage.id } })
      this.activeClass = 'active mobile-panel-view'
    },
    handleDeleteBatchClick() {
      if (this.checkedMessages.length > 1) {
        this.showDeleteConfirm = true
      } else {
        this.handleDeleteBatchConfirm()
      }
    },
    handleDeleteBatchClose() {
      this.showDeleteConfirm = false
    },
    handleDeleteBatchConfirm() {
      this.$store.dispatch('putMessagesDelete', this.checkedMessageIds).then(response => {
        this.handleDeleteBatchClose()
      })
    },
    handleSelectedDeleteClick() {
      this.$store.dispatch('putMessagesDelete', [this.selectedMessage.id]).then(response => {})
    },
    handleToggleChecked(index: number) {
      this.notifications.messages[index].isChecked = !this.notifications.messages[index].isChecked
    },
    handleRemoveAlertsClick() {
      this.$store.dispatch('putMessagesClearAlerts', this.checkedMessageIds).then(response => {})
    },
    handleMobileTabViewClick() {
      this.activeClass = 'active mobile-tab-view'
    },
    setSelectedMessageAsRead() {
      if (this.selectedMessage && !this.selectedMessage.isRead) {
        this.$store.dispatch('putMessagesRead', [this.selectedMessage.id]).then(response => {})
      }
    },
    checkQueryForMessageIds(id?: string) {
      const self = this
      const messageId = id ? id : this.$route.query.message
      if (
        this.notifications &&
        this.notifications.messages &&
        this.notifications.messages.length &&
        messageId
      ) {
        this.notifications.messages.forEach(function(message: any, index: number) {
          if (message.id == messageId) {
            setTimeout(() => {
              ;(self as any).$refs.messageTabs.$el
                .querySelector('.active')
                .scrollIntoView(true, { behavior: 'smooth', block: 'nearest' })
            })
            self.open()
            self.activeTab = index
          }
        })
      }
    },
  },
  created() {
    this.closed()
    AppHub.$on('refresh', this.fetchData)
    this.fetchData()
    MessageHub.$on('openNotifications', this.open)
    MessageHub.$on('closeNotifications', this.close)
    MessageHub.$on('updateNotifications', this.update)
    this.refreshTimer = setInterval(() => {
      this.fetchData(true)
    }, 60 * 1000) as any
  },
  beforeDestroy() {
    AppHub.$off('refresh', this.fetchData)
    MessageHub.$off('openNotifications', this.open)
    MessageHub.$off('closeNotifications', this.close)
    MessageHub.$off('updateNotifications', this.update)
    clearInterval(this.refreshTimer as any)
  },
  watch: {
    $route(to, from) {
      if (!this.isOpen) {
        this.checkQueryForMessageIds(to.query.message)
      }
    },
  },
})
